(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    class BuyButtons extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.form.addEventListener('submit', (event) => {
        // BUY NOW carries return_to=/checkout — let the native submit redirect.
        if (event.submitter && event.submitter.name === 'return_to') return;
        event.preventDefault();

        var sellingPlanInput = this.form.querySelector('input[name="selling_plan"]');
        var purchase = event.submitter && event.submitter.value;
        var sellingPlanId = '';

        if (purchase === 'subscription') {
          sellingPlanId = this.dataset.sellingPlanId || '';
        }

        if (sellingPlanInput) {
          sellingPlanInput.value = sellingPlanId;
        }

        this.addToCart(sellingPlanId);
      });
    }

    addToCart(sellingPlanId) {
      var self = this;
      var form = this.form;
      var idField = form.elements.namedItem('id');
      var id = idField ? idField.value : '';
      if (!id) return;
      var item = { id: Number(id), quantity: 1 };
      if (sellingPlanId) {
        item.selling_plan = Number(sellingPlanId);
      }
      var properties = {};
      var propInputs = form.querySelectorAll('input[name^="properties["]');
      for (var i = 0; i < propInputs.length; i++) {
        var name = propInputs[i].name;
        var start = name.indexOf('[') + 1;
        var end = name.lastIndexOf(']');
        var key = end > start ? name.slice(start, end) : '';
        if (key && propInputs[i].value) properties[key] = propInputs[i].value;
      }
      if (Object.keys(properties).length) item.properties = properties;

      this.setError('');
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] }),
      })
        .then(function (res) {
          if (!res.ok) {
            // Cart API errors (e.g. sold out mid-session) come back localised
            // in `description` — surface them inline instead of navigating.
            return res.json().then(function (data) {
              self.setError(data.description || data.message);
            });
          }
          var addEvent = new CustomEvent('cart:add', {
            bubbles: true,
            cancelable: true,
            detail: { id: item.id },
          });
          if (!self.dispatchEvent(addEvent)) return;
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          } else {
            window.location.href = window.Shopify.routes.root + 'cart';
          }
        })
        .catch(function () {
          self.setError(self.dataset.errorFallback);
        });
    }

    setError(message) {
      var el = this.querySelector('[data-cart-error]');
      if (!el) return;
      el.textContent = message || '';
      el.hidden = !message;
    }
  }
  if (!customElements.get('buy-buttons')) {
    customElements.define('buy-buttons', BuyButtons);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["countdown"] && !Shopify.designMode) return;
  try {
    class CountDown extends HTMLElement {
    connectedCallback() {
      this.deadline = new Date(this.dataset.deadline).getTime();
      this.els = {
        days: this.querySelector('[data-days]'),
        hours: this.querySelector('[data-hours]'),
        minutes: this.querySelector('[data-minutes]'),
        seconds: this.querySelector('[data-seconds]'),
      };
      if (isNaN(this.deadline)) return;
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    pad(n) {
      return String(Math.max(0, n)).padStart(2, '0');
    }

    tick() {
      let diff = Math.floor((this.deadline - Date.now()) / 1000);
      if (diff <= 0) {
        diff = 0;
        clearInterval(this.timer);
      }
      if (this.els.days) {
        this.els.days.textContent = this.pad(Math.floor(diff / 86400));
        this.els.hours.textContent = this.pad(Math.floor((diff % 86400) / 3600));
      } else {
        this.els.hours.textContent = this.pad(Math.floor(diff / 3600));
      }
      this.els.minutes.textContent = this.pad(Math.floor((diff % 3600) / 60));
      this.els.seconds.textContent = this.pad(diff % 60);
    }
  }

  if (!customElements.get('count-down')) {
    customElements.define('count-down', CountDown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["deferred-media"] && !Shopify.designMode) return;
  try {
    class DeferredMedia extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-autoplay')) {
        this.honorMotionPreference();
        return;
      }
      const button = this.querySelector('button');
      if (button) button.addEventListener('click', () => this.load(), { once: true });
    }
    honorMotionPreference() {
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const video = this.querySelector('video');
      if (video && typeof video.pause === 'function') {
        video.pause();
        video.removeAttribute('autoplay');
        return;
      }
      const iframe = this.querySelector('iframe');
      if (iframe && iframe.src) {
        iframe.src = iframe.src.replace('autoplay=1', 'autoplay=0');
      }
    }
    load() {
      const template = this.querySelector('template');
      if (!template) return;
      const media = template.content.firstElementChild.cloneNode(true);
      this.replaceChildren(media);
      if (media.tagName === 'VIDEO' && typeof media.play === 'function') media.play();
    }
  }
  if (!customElements.get('deferred-media')) {
    customElements.define('deferred-media', DeferredMedia);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["facet-filter"] && !Shopify.designMode) return;
  try {
    class FacetFilter extends HTMLElement {
    connectedCallback() {
      this.filters = {};
      this.grid = document.getElementById(this.dataset.target);
      this.cards = this.grid ? Array.from(this.grid.querySelectorAll('[data-card]')) : [];

      this.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-filter-toggle]');
        if (toggle) { this.toggleFacets(toggle); return; }
        const chip = event.target.closest('[data-filter-group]');
        if (chip) this.selectChip(chip);
      });
    }

    toggleFacets(toggle) {
      const facets = this.querySelector('#' + toggle.getAttribute('aria-controls'));
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      if (facets) facets.hidden = open;
    }

    selectChip(chip) {
      const group = chip.dataset.filterGroup;
      this.querySelectorAll('[data-filter-group="' + group + '"]').forEach((c) => {
        const active = c === chip;
        c.classList.toggle('is-active', active);
        c.setAttribute('aria-pressed', String(active));
      });
      this.filters[group] = chip.dataset.filterValue || '';
      this.apply();
    }

    apply() {
      this.cards.forEach((card) => {
        const match = Object.keys(this.filters).every((group) => {
          const value = this.filters[group];
          return !value || (card.dataset[group] || '') === value;
        });
        card.hidden = !match;
      });
    }
  }
  if (!customElements.get('facet-filter')) customElements.define('facet-filter', FacetFilter);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nna-upsell-element"] && !Shopify.designMode) return;
  try {
    class NnaUpsell extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-nna-dialog]');
      if (!this.dialog) return;

      var self = this;
      this.termsPanel = this.querySelector('[data-nna-terms]');
      this.querySelectorAll('[data-nna-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          self.dialog.close();
        });
      });
      this.dialog.addEventListener('click', function (event) {
        if (event.target === self.dialog) self.dialog.close();
      });
      this.dialog.addEventListener('cancel', function (event) {
        if (self.termsPanel && !self.termsPanel.hasAttribute('hidden')) {
          event.preventDefault();
          self.closeTerms();
        }
      });
      this.dialog.addEventListener('close', function () {
        self.closeTerms(false);
        self.toggleVideos(false);
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
      });

      if (this.termsPanel) {
        this.querySelectorAll('[data-nna-terms-open]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            self.openTerms();
          });
        });
        this.querySelectorAll('[data-nna-terms-close]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            self.closeTerms();
          });
        });
      }

      this.onCartAdd = function (event) {
        if (self.contains(event.target)) {
          self.track('collexable:nna_upsell_added');
          event.preventDefault();
          self.dialog.close();
          return;
        }
        var section = self.closest('.shopify-section');
        if (!section || !section.contains(event.target)) return;
        event.preventDefault();
        self.open();
      };
      document.addEventListener('cart:add', this.onCartAdd);

      this.querySelectorAll('form[data-nna-ajax]').forEach(function (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          self.addFromForm(form);
        });
      });

      this.fillCustomerName();
      this.pullIncludes();
      this.pullCopies();
    }

    // Move "Show inside upsell overlay" sections (hidden on the page) into the
    // overlay body — the whole Shopify section wrapper, so styles match.
    pullIncludes() {
      var slot = this.querySelector('[data-nna-includes]');
      if (!slot) return;
      document.querySelectorAll('[data-upsell-include]').forEach(function (root) {
        if (slot.contains(root)) return;
        var wrapper = root.closest('.shopify-section') || root;
        root.style.display = '';
        slot.appendChild(wrapper);
      });
    }

    // Copy (not move) sections flagged `data-upsell-copy` into the overlay —
    // the page keeps its own. Ids are stripped so the page stays unique.
    pullCopies() {
      var slot = this.querySelector('[data-nna-copies]');
      if (!slot) return;
      document.querySelectorAll('[data-upsell-copy]').forEach(function (root) {
        if (slot.contains(root)) return;
        var copy = (root.closest('.shopify-section') || root).cloneNode(true);
        copy.removeAttribute('id');
        copy.querySelectorAll('[id]').forEach(function (el) {
          el.removeAttribute('id');
        });
        copy.querySelectorAll('[data-upsell-copy]').forEach(function (el) {
          el.removeAttribute('data-upsell-copy');
        });
        if (copy.hasAttribute('data-upsell-copy')) copy.removeAttribute('data-upsell-copy');
        slot.appendChild(copy);
      });
    }

    // AJAX accept (both variants): add via the Cart API, then a
    // cancelable `cart:add` from the form lets onCartAdd track + close, and
    // the close handler opens the refreshed cart drawer.
    addFromForm(form) {
      var submit = form.querySelector('[type="submit"]');
      var errorEl = this.querySelector('[data-nna-error]');
      var fallback = errorEl ? errorEl.getAttribute('data-error-fallback') : '';
      var data = new FormData(form);
      var item = { id: Number(data.get('id')), quantity: 1, properties: {} };
      if (!item.id) return;
      var plan = data.get('selling_plan');
      if (plan) item.selling_plan = Number(plan);
      data.forEach(function (value, key) {
        var match = /^properties\[(.+)\]$/.exec(key);
        if (match) item.properties[match[1]] = value;
      });

      var showError = function (message) {
        if (submit) submit.disabled = false;
        if (!errorEl) return;
        errorEl.textContent = message || fallback;
        errorEl.hidden = false;
      };

      if (submit) submit.disabled = true;
      if (errorEl) errorEl.hidden = true;

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] }),
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (body) {
              showError(body.description || body.message);
            });
          }
          if (submit) submit.disabled = false;
          form.dispatchEvent(new CustomEvent('cart:add', {
            bubbles: true,
            cancelable: true,
            detail: { id: item.id },
          }));
        })
        .catch(function () {
          showError('');
        });
    }

    // First name for the priority offer: logged-in name is server-rendered
    // (data-known); otherwise the Klaviyo link param `fn`, kept for the
    // session and stripped from the URL so it stays out of analytics.
    fillCustomerName() {
      var slot = this.querySelector('[data-customer-name]');
      if (!slot) return;
      var name = '';
      try {
        var url = new URL(window.location.href);
        name = (url.searchParams.get('fn') || '').trim().slice(0, 40);
        if (url.searchParams.has('fn')) {
          url.searchParams.delete('fn');
          window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
        }
      } catch (error) {}
      if (slot.hasAttribute('data-known')) return;
      try {
        if (name) window.sessionStorage.setItem('collexable:fn', name);
        else name = window.sessionStorage.getItem('collexable:fn') || '';
      } catch (error) {}
      if (name) slot.textContent = name;
    }

    open() {
      if (this.dialog && typeof this.dialog.showModal === 'function' && !this.dialog.open) {
        this.dialog.showModal();
        // Focus the dialog, not the close bar: the overlay opens async after
        // ATC, so Safari would treat the bar as keyboard-focused and ring it.
        this.dialog.focus({ preventScroll: true });
        this.toggleVideos(true);
        this.track('collexable:nna_upsell_viewed');
      }
    }

    openTerms() {
      if (!this.termsPanel || !this.termsPanel.hasAttribute('hidden')) return;
      this.termsPanel.removeAttribute('hidden');
      var closeBtn = this.termsPanel.querySelector('[data-nna-terms-close]');
      if (closeBtn) closeBtn.focus();
    }

    closeTerms(restoreFocus) {
      if (!this.termsPanel || this.termsPanel.hasAttribute('hidden')) return;
      this.termsPanel.setAttribute('hidden', '');
      if (restoreFocus === false) return;
      var openBtn = this.querySelector('[data-nna-terms-open]');
      if (openBtn) openBtn.focus();
    }

    toggleVideos(play) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.querySelectorAll('video[data-nna-video]').forEach(function (video) {
        if (!play) {
          video.pause();
          return;
        }
        if (reduce) return;
        var host = video.closest('[data-nna-video-host]');
        if (host) {
          video.addEventListener('playing', function () {
            host.setAttribute('data-playing', '');
          }, { once: true });
        }
        var attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') attempt.catch(function () {});
      });
    }

    // Web Pixels custom event (docs/GTM-DATALAYER.md §3.2). Payload comes from
    // server-rendered data attributes; must never break the buy flow.
    track(name) {
      var shopify = window.Shopify;
      if (!shopify || shopify.designMode) return;
      if (!shopify.analytics || typeof shopify.analytics.publish !== 'function') return;
      var d = this.dataset;
      try {
        shopify.analytics.publish(name, {
          upsell_source: d.upsellSource || 'pdp_popup',
          upsell_variant: d.upsellVariant || 'one_time',
          trigger_product: d.triggerProduct || '',
          product_handle: d.productHandle || '',
          product_title: d.productTitle || '',
          variant_id: d.variantId || '',
          price: Number(d.price) || 0,
          currency: d.currency || '',
          quantity: 1,
        });
      } catch (error) {}
    }

    disconnectedCallback() {
      if (this.onCartAdd) document.removeEventListener('cart:add', this.onCartAdd);
    }
  }
  if (!customElements.get('nna-upsell')) {
    customElements.define('nna-upsell', NnaUpsell);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.quote = this.querySelector('[data-quote]');
      this.dots = Array.from(this.querySelectorAll('.media-gallery__dot'));
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => this.scrollBySlide(-1));
      if (next) next.addEventListener('click', () => this.scrollBySlide(1));
      if (this.track && (this.dots.length || this.quote || prev)) {
        this.track.addEventListener('scroll', () => this.syncSlide(), { passive: true });
        this.syncSlide();
      }
    }
    slides() {
      return Array.from(this.track.querySelectorAll('[data-slide]'));
    }
    isVertical() {
      return getComputedStyle(this.track).flexDirection === 'column';
    }
    padTop() {
      if (!this.isVertical()) return 0;
      return parseFloat(getComputedStyle(this.track).paddingTop) || 0;
    }
    currentIndex() {
      var slides = this.slides();
      if (!slides.length) return 0;
      var vertical = this.isVertical();
      var pos = vertical ? this.track.scrollTop + this.padTop() : this.track.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      for (var i = 0; i < slides.length; i++) {
        var offset = vertical ? slides[i].offsetTop : slides[i].offsetLeft;
        var dist = Math.abs(offset - pos);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      return best;
    }
    scrollBySlide(dir) {
      var slides = this.slides();
      if (!slides.length) return;
      var next = Math.max(0, Math.min(slides.length - 1, this.currentIndex() + dir));
      var behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      if (this.isVertical()) {
        this.track.scrollTo({ top: slides[next].offsetTop - this.padTop(), behavior: behavior });
      } else {
        this.track.scrollTo({ left: slides[next].offsetLeft, behavior: behavior });
      }
    }
    syncSlide() {
      var index = this.currentIndex();
      this.dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === index);
      });
      if (this.quote) this.quote.classList.toggle('is-hidden', index !== 0);
      this.classList.toggle('is-start', index === 0);
      this.classList.toggle('is-end', index === this.slides().length - 1);
    }
    showMedia(mediaId) {
      if (!mediaId || !this.track) return;
      var slides = this.slides();
      var match = null;
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) {
          match = slides[i];
          break;
        }
      }
      if (!match) return;
      var behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      if (this.isVertical()) {
        this.track.scrollTo({ top: match.offsetTop - this.padTop(), behavior: behavior });
      } else {
        this.track.scrollTo({ left: match.offsetLeft, behavior: behavior });
      }
    }
  }
  if (!customElements.get('media-gallery')) {
    customElements.define('media-gallery', MediaGallery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-input"] && !Shopify.designMode) return;
  try {
    class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-quantity-field]');
      if (!this.input) return;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-quantity-step]');
        if (!button || button.disabled) return;
        const step = Number(this.input.step) || 1;
        const next = this.clamp(Number(this.input.value) + Number(button.dataset.quantityStep) * step);
        if (next === Number(this.input.value)) return;
        this.input.value = next;
        this.sync();
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      this.input.addEventListener('input', () => this.sync());
    }

    clamp(value) {
      const min = Number(this.input.dataset.quantityMin) || 1;
      const max = this.input.max === '' ? Infinity : Number(this.input.max);
      return Math.min(max, Math.max(min, value));
    }

    sync() {
      const value = Number(this.input.value);
      const min = Number(this.input.dataset.quantityMin) || 1;
      const max = this.input.max === '' ? Infinity : Number(this.input.max);
      const minus = this.querySelector('[data-quantity-step="-1"]');
      const plus = this.querySelector('[data-quantity-step="1"]');
      if (minus) minus.disabled = value <= min;
      if (plus) plus.disabled = value >= max;
    }
  }
  if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sold-out-overlay"] && !Shopify.designMode) return;
  try {
    class SoldOutOverlay extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-sold-out-dialog]');
      if (!this.dialog) return;
      var self = this;
      this.adoptForm();
      var section = this.closest('.shopify-section');
      if (section && !this._formAdopted) {
        this.formObserver = new MutationObserver(function () {
          self.adoptForm();
        });
        this.formObserver.observe(section, { childList: true, subtree: true });
      }
      var closes = this.querySelectorAll('[data-sold-out-close]');
      for (var i = 0; i < closes.length; i++) {
        closes[i].addEventListener('click', function () {
          self.dialog.close();
        });
      }
      this.dialog.addEventListener('click', function (event) {
        if (event.target === self.dialog) self.dialog.close();
      });
    }

    adoptForm() {
      if (this._formAdopted) return;
      var slot = this.querySelector('[data-sold-out-form]');
      var section = this.closest('.shopify-section');
      if (!slot || !section) return;
      var form = section.querySelector('.main-product__info .cxf-form-wrapper');
      if (!form) return;
      var host = form.closest('.main-product__app');
      slot.appendChild(form);
      if (host && host.parentNode) host.parentNode.removeChild(host);
      this._formAdopted = true;
      if (this.formObserver) {
        this.formObserver.disconnect();
        this.formObserver = null;
      }
    }

    open(variantId) {
      this.adoptForm();
      this.showVariant(variantId);
      if (this.dialog && typeof this.dialog.showModal === 'function' && !this.dialog.open) {
        this.dialog.showModal();
      }
    }

    showVariant(variantId) {
      var id = variantId ? String(variantId) : '';
      var coins = this.querySelectorAll('[data-sold-out-coin]');
      var titles = this.querySelectorAll('[data-title-variant]');
      var fallback = this.querySelector('[data-title-fallback]');
      var grid = this.querySelector('[data-sold-out-coins]');
      var shown = 0;
      var titleMatch = false;
      var i;
      var match;

      for (i = 0; i < coins.length; i++) {
        match = !id || !coins[i].getAttribute('data-variant-id') || coins[i].getAttribute('data-variant-id') === id;
        coins[i].hidden = !match;
        if (match) shown += 1;
      }

      for (i = 0; i < titles.length; i++) {
        match = id !== '' && titles[i].getAttribute('data-title-variant') === id;
        titles[i].hidden = !match;
        if (match) titleMatch = true;
      }
      if (fallback) fallback.hidden = titleMatch;

      if (grid) {
        if (shown <= 1) grid.classList.add('sold-out-overlay__coins--one');
        else grid.classList.remove('sold-out-overlay__coins--one');
      }
    }

    disconnectedCallback() {
      if (this.formObserver) this.formObserver.disconnect();
    }
  }
  if (!customElements.get('sold-out-overlay')) {
    customElements.define('sold-out-overlay', SoldOutOverlay);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["stacked-alpha-video"] && !Shopify.designMode) return;
  try {
    /*
   * stacked-alpha-video 1.0.10 — Copyright Jake Archibald.
   * Licensed under the Apache License, Version 2.0:
   * http://www.apache.org/licenses/LICENSE-2.0
   */
  (() => {
    if (customElements.get('stacked-alpha-video')) return;
    if (!('replaceSync' in CSSStyleSheet.prototype)) return;

    const fragmentShaderSource = `
      precision mediump float;
      uniform sampler2D u_frame;
      uniform float u_premultipliedAlpha;
      varying vec2 v_texCoord;

      void main() {
        vec2 colorCoord = vec2(v_texCoord.x, v_texCoord.y * 0.5);
        vec2 alphaCoord = vec2(v_texCoord.x, 0.5 + v_texCoord.y * 0.5);
        vec4 color = texture2D(u_frame, colorCoord);
        float alpha = texture2D(u_frame, alphaCoord).r;
        gl_FragColor = vec4(color.rgb * mix(alpha, 1.0, u_premultipliedAlpha), alpha);
      }
    `;

    const vertexShaderSource = `
      precision mediump float;
      attribute vec2 a_position;
      uniform mat3 u_matrix;
      varying vec2 v_texCoord;

      void main() {
        gl_Position = vec4(u_matrix * vec3(a_position, 1), 1);
        v_texCoord = a_position;
      }
    `;

    function loadShader(gl, source, type) {
      const shader = gl.createShader(type);
      if (!shader) throw Error('Unable to create shader');
      gl.shaderSource(shader, source);
      gl.compileShader(shader);
      if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
        const error = gl.getShaderInfoLog(shader);
        gl.deleteShader(shader);
        throw Error(error || 'unknown error');
      }
      return shader;
    }

    function createProgram(gl, shaders) {
      const program = gl.createProgram();
      if (!program) throw Error('Unable to create program');
      for (const shader of shaders) gl.attachShader(program, shader);
      gl.linkProgram(program);
      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
        const error = gl.getProgramInfoLog(program);
        gl.deleteProgram(program);
        throw Error(error || 'unknown error');
      }
      return program;
    }

    const premultipliedAlphaLocations = new WeakMap();

    function setPremultipliedAlpha(context, premultipliedAlpha) {
      context.uniform1f(premultipliedAlphaLocations.get(context), premultipliedAlpha ? 1 : 0);
    }

    function setupGLContext(canvas) {
      const options = { antialias: false, powerPreference: 'low-power', depth: false, premultipliedAlpha: true };
      const context = canvas.getContext('webgl2', options) ?? canvas.getContext('webgl', options);
      if (!context) throw Error("Couldn't create GL context");

      const frag = loadShader(context, fragmentShaderSource, context.FRAGMENT_SHADER);
      const vert = loadShader(context, vertexShaderSource, context.VERTEX_SHADER);
      const program = createProgram(context, [frag, vert]);
      context.useProgram(program);

      const positionLocation = context.getAttribLocation(program, 'a_position');
      context.uniform1i(context.getUniformLocation(program, 'u_frame'), 0);
      const matrixLoc = context.getUniformLocation(program, 'u_matrix');
      premultipliedAlphaLocations.set(context, context.getUniformLocation(program, 'u_premultipliedAlpha'));
      setPremultipliedAlpha(context, false);

      const positionBuffer = context.createBuffer();
      const rect = new Float32Array([0, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1]);
      context.bindBuffer(context.ARRAY_BUFFER, positionBuffer);
      context.bufferData(context.ARRAY_BUFFER, rect, context.STATIC_DRAW);
      context.enableVertexAttribArray(positionLocation);
      context.vertexAttribPointer(positionLocation, 2, context.FLOAT, false, 0, 0);
      context.uniformMatrix3fv(matrixLoc, false, [2, 0, 0, 0, -2, 0, -1, 1, 1]);

      const texture = context.createTexture();
      context.bindTexture(context.TEXTURE_2D, texture);
      context.texParameteri(context.TEXTURE_2D, context.TEXTURE_WRAP_S, context.CLAMP_TO_EDGE);
      context.texParameteri(context.TEXTURE_2D, context.TEXTURE_WRAP_T, context.CLAMP_TO_EDGE);
      context.texParameteri(context.TEXTURE_2D, context.TEXTURE_MIN_FILTER, context.NEAREST);
      context.texParameteri(context.TEXTURE_2D, context.TEXTURE_MAG_FILTER, context.NEAREST);
      return context;
    }

    function drawVideo(context, video) {
      const canvas = context.canvas;
      const width = video.videoWidth;
      const height = Math.floor(video.videoHeight / 2);
      if (canvas.width !== width || canvas.height !== height) {
        canvas.width = width;
        canvas.height = height;
        context.viewport(0, 0, width, height);
      }
      context.texImage2D(context.TEXTURE_2D, 0, context.RGBA, context.RGBA, context.UNSIGNED_BYTE, video);
      context.drawArrays(context.TRIANGLES, 0, 6);
    }

    const styles = new CSSStyleSheet();
    styles.replaceSync(`
      :host { display: inline-block; height: auto; }
      canvas {
        display: block;
        width: inherit;
        object-fit: inherit;
        aspect-ratio: inherit;
        height: inherit;
      }
    `);

    function videoIsPlaying(video) {
      return !video.paused && !video.ended && video.readyState > 2;
    }

    class StackedAlphaVideo extends HTMLElement {
      static observedAttributes = ['premultipliedalpha'];
      #shadow = this.attachShadow({ mode: 'closed' });
      #canvas = document.createElement('canvas');
      #context = null;
      #video = null;
      #frameHandle = 0;
      #state = { videoPlaying: false, intersecting: false, connected: false };
      #pendingStateUpdate = false;
      #videoListenersController = null;

      constructor() {
        super();
        this.#shadow.adoptedStyleSheets = [styles];
        this.#shadow.append(this.#canvas);
        new IntersectionObserver(([entry]) => {
          this.#updateState({ intersecting: entry.isIntersecting });
        }).observe(this);
        new MutationObserver(() => {
          if (this.firstElementChild !== this.#video) this.#videoChange(this.firstElementChild);
        }).observe(this, { childList: true });
        this.#videoChange(this.firstElementChild);
      }

      #frame = () => {
        if (!this.#video) return;
        if (!this.#context) {
          this.#canvas.remove();
          this.#canvas = document.createElement('canvas');
          this.#shadow.append(this.#canvas);
          try {
            this.#context = setupGLContext(this.#canvas);
          } catch (err) {
            console.warn("<stacked-alpha-video> Couldn't create GL context");
          }
          if (!this.#context) return;
          setPremultipliedAlpha(this.#context, this.premultipliedAlpha);
        }
        drawVideo(this.#context, this.#video);
        if (this.#state.videoPlaying) this.#frameHandle = requestAnimationFrame(this.#frame);
      };

      #updateState(newState) {
        Object.assign(this.#state, newState);
        if (this.#pendingStateUpdate) return;
        this.#pendingStateUpdate = true;
        queueMicrotask(() => {
          this.#pendingStateUpdate = false;
          const { connected, intersecting } = this.#state;
          cancelAnimationFrame(this.#frameHandle);
          if (!connected || !intersecting) {
            if (this.#context) {
              this.#context.getExtension('WEBGL_lose_context')?.loseContext();
              this.#context = null;
            }
            return;
          }
          this.#frameHandle = requestAnimationFrame(this.#frame);
        });
      }

      #videoChange(newVideo) {
        if (this.#videoListenersController) this.#videoListenersController.abort();
        if (newVideo && !(newVideo instanceof HTMLVideoElement)) {
          console.warn('<stacked-alpha-video> Child must be a <video>');
          this.#video = null;
          this.#updateState({ videoPlaying: false });
          return;
        }
        this.#video = newVideo;
        if (!newVideo) {
          this.#updateState({ videoPlaying: false });
          return;
        }
        if (newVideo.autoplay) {
          // Safari only honours this if a task is queued.
          setTimeout(() => {
            newVideo.play().catch(() => {});
          }, 0);
        }
        const videoUpdate = () => {
          this.#updateState({ videoPlaying: videoIsPlaying(newVideo) });
        };
        videoUpdate();
        this.#videoListenersController = new AbortController();
        const signal = this.#videoListenersController.signal;
        for (const event of ['playing', 'stalled', 'emptied', 'ended', 'pause']) {
          newVideo.addEventListener(event, videoUpdate, { signal });
        }
      }

      connectedCallback() {
        this.#updateState({ connected: true });
      }

      disconnectedCallback() {
        this.#updateState({ connected: false });
      }

      attributeChangedCallback(name, _, newValue) {
        if (name === 'premultipliedalpha' && this.#context) {
          setPremultipliedAlpha(this.#context, newValue !== null);
        }
      }

      get premultipliedAlpha() {
        return this.hasAttribute('premultipliedalpha');
      }

      set premultipliedAlpha(value) {
        this.toggleAttribute('premultipliedalpha', Boolean(value));
      }
    }

    customElements.define('stacked-alpha-video', StackedAlphaVideo);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-picker"] && !Shopify.designMode) return;
  try {
    class VariantPicker extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('[data-variant-select]');
      this.nameEl = this.querySelector('[data-selected-name]');
      this.inputs = this.querySelectorAll('.variant-picker__input');
      if (this.select) this.select.setAttribute('aria-hidden', 'true');
      if (!this.inputs.length) return;
      var self = this;
      for (var i = 0; i < this.inputs.length; i++) {
        this.inputs[i].addEventListener('click', function (event) {
          if (event.target.getAttribute('data-available') === 'false') {
            self.openSoldOut(event.target.value);
          }
        });
        this.inputs[i].addEventListener('change', function (event) {
          if (event.target.checked) self.apply(event.target);
        });
      }
    }

    openSoldOut(variantId) {
      var section = this.closest('.shopify-section');
      var overlay = section
        ? section.querySelector('sold-out-overlay')
        : document.querySelector('sold-out-overlay');
      if (overlay && typeof overlay.open === 'function') overlay.open(variantId);
    }

    apply(input) {
      var id = input.value;
      var name = input.getAttribute('data-option-name') || '';
      var available = input.getAttribute('data-available') !== 'false';
      var price = input.getAttribute('data-price') || '';
      var mediaId = input.getAttribute('data-media-id') || '';

      if (this.select) this.select.value = id;
      if (this.nameEl && name) this.nameEl.textContent = name;

      var copies = this.querySelectorAll('[data-copy]');
      for (var i = 0; i < copies.length; i++) {
        copies[i].hidden = copies[i].getAttribute('data-variant-id') !== id;
      }

      this.syncForm(id, available, price);
      this.syncGallery(mediaId);
      this.syncUrl(id);
    }

    syncForm(id, available, price) {
      var formId = this.getAttribute('data-form-id');
      var form = formId ? document.getElementById(formId) : null;
      if (!form) return;

      var idField = form.elements.namedItem('id');
      if (idField && idField.value !== id) idField.value = id;

      var amount = document.querySelector('.main-product__price .price__amount');
      if (amount && price) amount.textContent = price;

      var soldOut = this.getAttribute('data-sold-out') || '';
      var buttons = form.querySelectorAll('button[type="submit"]');
      for (var i = 0; i < buttons.length; i++) {
        var button = buttons[i];
        var label = button.querySelector('.button__label');
        if (available) {
          button.removeAttribute('disabled');
          if (label) {
            var live = button.getAttribute('data-available-label');
            if (live) label.textContent = live;
          }
        } else {
          button.setAttribute('disabled', '');
          if (label && soldOut) label.textContent = soldOut;
        }
      }
    }

    syncGallery(mediaId) {
      if (!mediaId) return;
      var gallery = document.querySelector('media-gallery');
      if (gallery && typeof gallery.showMedia === 'function') {
        gallery.showMedia(mediaId);
      }
    }

    syncUrl(id) {
      var productUrl = this.getAttribute('data-product-url');
      if (!productUrl || !window.history || !window.history.replaceState) return;
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {
        /* ignore */
      }
    }
  }
  if (!customElements.get('variant-picker')) {
    customElements.define('variant-picker', VariantPicker);
  }
  } catch(e) { console.error(e); }
})();

})();
